module.exports = __webpack_public_path__ + "static/media/apertechlogo.3047a446.png";